import { Component, Input } from '@angular/core';
import { Step } from '../../models/step.model';

@Component({
  selector: 'shared-steps',
  templateUrl: './steps.component.html',
  styleUrl: './steps.component.scss',
  imports: [],
})
export class StepsComponent {
  @Input({ required: true }) steps: Step[] = [];
  @Input() colourHex = '#fff';
}
